// extracted by mini-css-extract-plugin
export default {"form-control":"App_form-control__LMxfq","App":"App_App__B2Ebb"};